<template>
  <main-template hide-franquia>
    <v-row>
      <v-col cols="12">
        <h1>Presenças do aluno</h1>
      </v-col>

      <v-col cols="12" md="3">
        <v-text-field v-model="filtroData" label="Data" type="date" dense outlined />
      </v-col>

      <v-col cols="12" md="3">
        <v-select
          v-model="filtroEvento"
          :items="eventos"
          label="Tipo de evento"
          item-text="text"
          item-value="value"
          dense
          outlined
          clearable
        />
      </v-col>

      <v-col cols="12" md="3" class="d-flex align-center">
        <v-btn color="primary" small @click="buscarPresencas">Buscar</v-btn>
      </v-col>

      <v-col cols="12" md="3" class="d-flex align-center justify-end">
        <v-chip small color="green" text-color="white" class="mr-2"
          >Entradas: {{ totalEntradas }}</v-chip
        >
        <v-chip small color="orange" text-color="white">Saídas: {{ totalSaidas }}</v-chip>
      </v-col>

      <v-col cols="12">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">ID</th>
                <th class="text-left">Data</th>
                <th class="text-left">Hora</th>
                <th class="text-left">Tipo de Evento</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="presenca in presencas" :key="presenca.id">
                <td>{{ presenca.id }}</td>
                <td>{{ formatDate(presenca.data_evento) }}</td>
                <td>{{ formatTime(presenca.data_evento) }}</td>
                <td>
                  <v-chip
                    x-small
                    :color="presenca.evento === 0 ? 'green' : 'orange'"
                    text-color="white"
                  >
                    {{ presenca.evento === 0 ? "Entrada" : "Saída" }}
                  </v-chip>
                </td>
              </tr>
              <tr v-if="presencas.length === 0">
                <td colspan="4" class="text-center">Nenhum registro encontrado.</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </main-template>
</template>

<script>
export default {
  props: {
    matricula_id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      presencas: [],
      filtroData: null,
      filtroEvento: null,
      eventos: [
        { text: "Entrada", value: 0 },
        { text: "Saída", value: 1 },
      ],
    };
  },
  computed: {
    totalEntradas() {
      return this.presencas.filter((p) => p.evento === 0).length;
    },
    totalSaidas() {
      return this.presencas.filter((p) => p.evento === 1).length;
    },
  },
  mounted() {
    this.buscarPresencas();
  },
  methods: {
    async buscarPresencas() {
      try {
        this.$loaderService.open("Carregando presenças...");
        const params = { matricula_id: this.matricula_id };
        if (this.filtroData) params.data = this.filtroData;
        if (this.filtroEvento !== null) params.evento = this.filtroEvento;

        const response = await this.$services.presencasService.getPresencasHikvision(params);
        this.presencas = response.presencas || [];
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    formatDate(value) {
      if (!value) return "-";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "-";
      return date.toLocaleDateString("pt-BR");
    },
    formatTime(value) {
      if (!value) return "-";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return "-";
      return date.toLocaleTimeString("pt-BR");
    },
  },
};
</script>
